var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quill-editor',_vm._g(_vm._b({directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"editor",attrs:{"options":_vm.editorOption},on:{"ready":_vm.handleReady}},'quill-editor',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }